import React from "react";
const IconCart = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path
      d="M7 6.889C7 4.74 8.343 3 10 3s3 1.741 3 3.889m-9 0h12L15 17H5L4 6.889Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinejoin="bevel"
    />
  </svg>
);
export default IconCart;
